import React, { useState, useEffect, useRef } from 'react';

function ComboPromo({ onCategorySelect }) {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const fullTitle = 'Arrendamiento\nMensual\nPremium';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const comboFeatures = [
    {
      id: 1,
      title: 'Relleno Mensual',
      subtitle: 'Aroma Premium',
      image: '/images/products/aceitearomatico.jpeg',
      icon: '🫗'
    },
    {
      id: 2,
      title: 'Mantenimiento',
      subtitle: 'Servicio Completo',
      image: '/images/products/difusores.jpeg',
      icon: '🔧'
    },
    {
      id: 3,
      title: 'Atención Inmediata',
      subtitle: 'Soporte 24/7',
      image: '/images/products/difnegro.jpeg',
      icon: '⚡'
    }
  ];

  // Calcular cuál card debe estar visible basado en el progreso
  // const getCurrentCardIndex = () => {
  //   return Math.floor(scrollProgress * comboFeatures.length);
  // };

  // const currentIndex = getCurrentCardIndex();

  const handleComboClick = () => {
    // Enviar mensaje de WhatsApp para el combo
    const message = `Hola, me interesa el combo:%0A%0A`;
    const comboMessage = `*💼 Arrendamiento Mensual Premium*%0A`;
    const price = `Precio: MXN$1,800 mensual%0A%0A`;
    const features = `Incluye:%0A✔️ Relleno mensual del tanque con aroma premium%0A✔️ Mantenimiento mensual del difusor%0A✔️ Atención inmediata en caso de fallas%0A✔️ Reemplazo del difusor por uno nuevo en caso de falla de fábrica`;
    
    const phoneNumber = '5218123225278';
    const url = `https://wa.me/${phoneNumber}?text=${message}${comboMessage}${price}${features}`;
    window.open(url, '_blank');
  };

  return (
    <section className="combo-promo" ref={sectionRef}>
      <div className="combo-content">
        <div className="combo-left">
          <h2 className="combo-title">
            {fullTitle.split('\n').map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {line.split('').map((char, charIndex) => (
                  <span
                    key={`${lineIndex}-${charIndex}`}
                    className="letter-fade-combo"
                    style={{ animationDelay: `${5 + (lineIndex * line.length + charIndex) * 0.08}s` }}
                  >
                    {char === ' ' ? '\u00A0' : char}
                  </span>
                ))}
                {lineIndex < fullTitle.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </h2>
          <div className="combo-price">
            <span className="price-currency">MXN$</span>
            <span className="price-amount">1,800</span>
            <span className="price-period">/mes</span>
          </div>
        </div>

        <div className="combo-center">
          <div className="combo-cards-container">
            {comboFeatures.map((feature, index) => (
              <div 
                key={feature.id} 
                className="combo-card visible"
                style={{ 
                  animationDelay: `${1 + index * 0.2}s`,
                  cursor: 'pointer'
                }}
                onClick={handleComboClick}
              >
                <div className="combo-card-icon">
                  {feature.icon}
                </div>
                <div className="combo-card-image">
                  <img src={feature.image} alt={feature.title} />
                </div>
                <div className="combo-card-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="combo-right">
          <div className="combo-description">
            <p>
              <strong>💼 El plan perfecto para tu negocio</strong> que incluye todo lo necesario para mantener tu espacio con el mejor aroma sin preocupaciones.
            </p>
            <div className="combo-features">
              <h4>✨ Qué incluye:</h4>
              <ul>
                <li>✔️ <strong>Relleno mensual</strong> con aroma premium</li>
                <li>✔️ <strong>Mantenimiento completo</strong> del difusor</li>
                <li>✔️ <strong>Atención inmediata</strong> en caso de fallas</li>
                <li>✔️ <strong>Reemplazo garantizado</strong> sin costo extra</li>
              </ul>
            </div>
            <div className="combo-cta">
              <button className="combo-btn" onClick={handleComboClick}>
                💬 Cotizar Ahora
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ComboPromo;